import Card from "@elsa-zku/lib/components/Card";
import Select from "@elsa-zku/lib/components/Select";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { selectBuilding, useBuildingsList, useSelectedBuildingId } from "src/store/buildings";
import { selectGroup, useGroupsList, useSelectedGroupId,  useModeGroupFilter } from "src/store/group";
import style from "./Header.scss";

type Props = {};

const Header: React.FC<Props> = (props) => {
  const {} = props;
  const location = useLocation();
  const modeGroup = useModeGroupFilter(); // :number Режим фильтрации панелей (1 - для ЖК; 0 - для подъездов)

  //Для: режима фильтра по домовым панелям
  const buildingId = useSelectedBuildingId(); // ID выбранного дома
  const buildingsList = useBuildingsList();
  const optionsBuildings = React.useMemo(
    () =>  buildingsList ? buildingsList.map(b => ({ label: b.name, value: b.id })) : [],
    [buildingsList]
  );

  //Для: режима фильтра по групповым панелям
  const groupId = useSelectedGroupId();       // ID выбранной группы
  const groupsList = useGroupsList();
  const optionsGroups = React.useMemo(
    () => groupsList ? groupsList.map(g => ({ label: g.name, value: g.id })) : [],
    [groupsList]
  );

  const gMode = React.useMemo(
    () => { //return 1 - показать выбор групп; 0 - показать выбор домов; -1 - выключить выбор дома
      const p = location.pathname;
      if ('/groups' == p) return -1;  // отключ. выбор дома для страницы "Группы домов"
      if ('/buildings' == p) return 1 // показ. выбор групп для страницы "Дома"
      return ('/gates' == p) ? modeGroup : 0; // показ. выбор гр для страницы "Панелей" в режиме групповых панелей, а для домовых панелей показать дом (modeGroup=0); в остальных слуячаях по прежнему показ дома
    },
    [location.pathname, modeGroup]
  );

  return (
    <div className={style.container}>
      <Card rawBody>
        <div className={style.cardWrapper}>
          <div className={style.card}>
            {!!Math.abs(gMode) ?
            <Select disabled={gMode<0} label="Выбранная группа домов" options={optionsGroups} value={groupId} onChange={selectGroup} /* isClearable={true} */ />
            :
            <Select disabled={gMode<0} label="Выбранный дом"          options={optionsBuildings} value={buildingId} onChange={selectBuilding} />
          }
          </div>
        </div>
      </Card>
    </div>
  );
};

export default React.memo(Header);
